import { Spinner, SpinnerSize, Stack } from '@fluentui/react';
import { useEffect, useRef, useState } from 'react';

import { postAsync } from '../../../../utils/api';
import AccountField from './AccountField';

type Props = {
  label: string;
  variable: string;
  defaultValue?: string;
  isMultiline?: boolean;
  email?: boolean;
  onChange?: (value: string) => any;
};

export default (props: Props) => {
  const [addressInfo, setAddressInfo] = useState<string>();
  const [query, setQuery] = useState<string>();
  const [loading, setLoading] = useState<boolean>();
  const hashRef = useRef<string>();

  useEffect(() => {
    const hash = Date.now().toString();
    hashRef.current = hash;

    setAddressInfo(undefined);
    setLoading(!!query);

    if (!query) return;

    setTimeout(() => {
      if (hash !== hashRef.current) return;

      postAsync("/maps/fetch-address", { address: query }).then((res) => {
        if (res.success) {
          const info = res.data;
          setAddressInfo(`${info.street} ${info.subCity}/${info.city}`);
        }

        setLoading(false);
      });
    }, 1750);
  }, [query]);

  return (
    <Stack horizontalAlign="start" tokens={{ childrenGap: 5 }}>
      <AccountField
        label={props.label}
        variable={props.variable}
        onChange={(v) => setQuery(v)}
        isMultiline
      />
      {loading ? (
        <Spinner
          size={SpinnerSize.small}
          label="Harita bilgisi alınıyor."
          labelPosition="right"
        />
      ) : addressInfo ? (
        <Stack.Item>{addressInfo}</Stack.Item>
      ) : (
        <></>
      )}
    </Stack>
  );
};
